import React from "react";
import "../../css/Wireframe.css";
import Footer from "../../components/Footer";
import Banner from "../../components/Banner";
import Select from "react-select";
import axios from "axios";
import OtpInput from "../../components/OtpInput";
import Spinner from "../../components/Spinner";

const API = localStorage.getItem("assethost");
const emailRegex =
  /^[\w.!#$%&'*+/=?^`{|}~-]+@[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?(?:\.[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?)+$/i;
const emailError = "Please enter a valid email address (e.g. name@example.com)";
const passwordRegex =
  // eslint-disable-next-line no-useless-escape
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;
const passwordError =
  "Password must be at least 8 characters, with uppercase, lowercase, number, and symbol.";
const usernameRegex = /^(?!\s*$)[-_a-zA-Z0-9 ]*$/;
const usernameError =
  "Username should only contain letters, digits, dash, or underscore";
const phoneRegex =
  /^\+?[0-9]{1,4}?[-.\s]?\(?[0-9]{1,3}?\)?[-.\s]?[0-9]{3,4}[-.\s]?[0-9]{3,4}$/;
const phoneError = "Not a valid phone number";
const nationalIdRegex = /^\d{2}-\d{6,7}[A-Z]\d{2}$/;
const ogPlaceholder = "00-000000(0)A00";
const placeholder1 = "00-000000A00";
const placeholder2 = "00-0000000A00";

function dynamicNationalIdError(id) {
  const start = "Accepted format for national ID is ";
  let last = "";
  if (id.length >= 10 && /[A-Z]/.test(id[9])) {
    last = id + placeholder1.substring(id.length);
  } else if (id.length >= 10) {
    last = id + placeholder2.substring(id.length);
  } else {
    last = id + ogPlaceholder.substring(id.length);
  }
  return start + last;
}

function getNestedValue(obj, path) {
  return path.split(".").reduce((acc, key) => acc && acc[key], obj);
}
function setNestedValue(obj, path, value) {
  const keys = path.split(".");
  const lastKey = keys.pop();
  const newObj = { ...obj };
  let curr = newObj;
  for (const k of keys) {
    curr[k] = { ...curr[k] };
    curr = curr[k];
  }
  curr[lastKey] = value;
  return newObj;
}

function formatNationalId(e, currentObject, field, isZimbabwean = true) {
  let currentValue = String(getNestedValue(currentObject, field) || "");
  let newValue = currentValue;
  let newPlaceholder =
    currentValue + ogPlaceholder.substring(currentValue.length);
  let error = "";
  e = e.toUpperCase();
  if (!isZimbabwean) {
    const updatedObject = setNestedValue(currentObject, field, e);
    return { newPlaceholder, error, updatedObject };
  }
  if (e.length > currentValue.length && nationalIdRegex.test(currentValue)) {
    return { newPlaceholder, error, updatedObject: currentObject };
  }
  if (nationalIdRegex.test(e)) {
    newValue = e;
    newPlaceholder = e;
  } else if (
    nationalIdRegex.test(e + placeholder1.substring(e.length)) ||
    nationalIdRegex.test(e + placeholder2.substring(e.length))
  ) {
    if (e.length >= 10) {
      if (/[A-Z]/.test(e[9])) {
        newValue = e;
        newPlaceholder = e + placeholder1.substring(e.length);
      } else {
        newValue = e;
        newPlaceholder = e + placeholder2.substring(e.length);
      }
    } else if (e.length === 2 && currentValue.length < 2) {
      newValue = e + "-";
      newPlaceholder = newValue + ogPlaceholder.substring(newValue.length);
    } else {
      newValue = e;
      newPlaceholder = e + ogPlaceholder.substring(e.length);
    }
  } else {
    error = dynamicNationalIdError(currentValue);
  }
  const updatedObject = setNestedValue(currentObject, field, newValue);
  return { newPlaceholder, error, updatedObject };
}

export default class Individual extends React.Component {
  constructor(props) {
    super(props);
    // All fields from original IndividualReg
    this.state = {
      firstname: "",
      middlename: "",
      surname: "",
      identification: "",
      passportNumber: "",
      nationality: "",
      townCityId: 0,
      email: "",
      cellphone: "",
      address: "",
      suburb: "",
      gender: "",
      username: "",
      password: "",
      passwordConfirm: "",
      serviceType: "",
      mobileMoney: "",
      errors: {},
      idPlaceholder: ogPlaceholder,
      msg: "",
      toastColor: "",
      individualLookupData: {},
      showCellVerifyPopup: false,
      showVerifyPopup: false,
      mobileMoneyVerified: false,
      cellOtp: "",
      cellOtpId: undefined,
      cellVerified: false,
      loading: false,
      valid: true,
    };
    this.handleRegister = this.handleRegister.bind(this);
    this.handleId = this.handleId.bind(this);
    this.getIndividualLookupData = this.getIndividualLookupData.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleVerifyMobileMoney = this.handleVerifyMobileMoney.bind(this);
    this.handleAcceptMobileMoney = this.handleAcceptMobileMoney.bind(this);
    this.handleCancelMobileMoney = this.handleCancelMobileMoney.bind(this);
    this.verifyCellphone = this.verifyCellphone.bind(this);
    this.verifyCellphoneOtp = this.verifyCellphoneOtp.bind(this);
  }

  componentDidMount() {
    this.getIndividualLookupData();
  }
  isZimbabwean() {
    return this.state.nationality === "ZW";
  }

  // Field change (input) handlers always call validate
  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value }, this.validate);
  }
  handleSelect(name, value) {
    this.setState({ [name]: value }, this.validate);
  }

  handleId(val, field = "identification") {
    const { newPlaceholder, error, updatedObject } = formatNationalId(
      val,
      this.state,
      field,
      this.isZimbabwean()
    );
    this.setState(
      {
        [field]: updatedObject[field],
        ...(field === "identification"
          ? { idPlaceholder: newPlaceholder }
          : {}),
        errors: { ...this.state.errors, [field]: error },
      },
      this.validate
    );
  }

  // Validation: no arrays, strict per-field if/else (patientaction.js style)
  validate() {
    let errors = {};
    let valid = true;
    // Firstname
    if (!this.state.firstname || !this.state.firstname.trim()) {
      errors.firstname = "Firstname is required";
      valid = false;
    }
    // Surname
    if (!this.state.surname || !this.state.surname.trim()) {
      errors.surname = "Surname is required";
      valid = false;
    }
    // Nationality
    if (!this.state.nationality || !this.state.nationality.trim()) {
      errors.nationality = "Nationality is required";
      valid = false;
    }
    // ID/Passport
    if (this.isZimbabwean()) {
      if (!this.state.identification || !this.state.identification.trim()) {
        errors.identification = "National ID is required";
        valid = false;
      } else if (!nationalIdRegex.test(this.state.identification)) {
        errors.identification = dynamicNationalIdError(
          this.state.identification
        );
        valid = false;
      }
    } else {
      if (!this.state.passportNumber || !this.state.passportNumber.trim()) {
        errors.passportNumber = "Passport Number is required";
        valid = false;
      }
    }
    // Address
    if (!this.state.address || !this.state.address.trim()) {
      errors.address = "House No & Street (address) is required";
      valid = false;
    }
    // Suburb
    if (!this.state.suburb || !this.state.suburb.trim()) {
      errors.suburb = "Suburb is required";
      valid = false;
    }
    // Town/City
    if (!this.state.townCityId || this.state.townCityId === 0) {
      errors.townCityId = "Town/City is required";
      valid = false;
    }
    // Gender
    if (!this.state.gender || !this.state.gender.trim()) {
      errors.gender = "Gender is required";
      valid = false;
    }
    // Username
    if (!this.state.username || !this.state.username.trim()) {
      errors.username = "Username is required";
      valid = false;
    } else if (!usernameRegex.test(this.state.username)) {
      errors.username = usernameError;
      valid = false;
    }
    // Password
    if (!this.state.password || !this.state.password.trim()) {
      errors.password = "Password is required";
      valid = false;
    } else if (!passwordRegex.test(this.state.password)) {
      errors.password = passwordError;
      valid = false;
    }
    // Password Confirm
    if (!this.state.passwordConfirm || !this.state.passwordConfirm.trim()) {
      errors.passwordConfirm = "Password confirm is required";
      valid = false;
    } else if (this.state.password !== this.state.passwordConfirm) {
      errors.passwordConfirm = "Passwords do not match";
      valid = false;
    } else if (!passwordRegex.test(this.state.passwordConfirm)) {
      errors.passwordConfirm = passwordError;
      valid = false;
    }
    // Service Type
    if (!this.state.serviceType || !this.state.serviceType.trim()) {
      errors.serviceType = "Service Type is required";
      valid = false;
    }
    // Cellphone
    if (!this.state.cellphone || !this.state.cellphone.trim()) {
      errors.cellphone = "Cellphone is required";
      valid = false;
    } else if (!phoneRegex.test(this.state.cellphone)) {
      errors.cellphone = phoneError;
      valid = false;
    } else if (!this.state.cellOtpId || this.state.cellOtpId === 0) {
      errors.cellphone = "Cellphone is not verified";
      valid = false;
    }
    // Email (optional, validate format if present)
    if (
      !!this.state.email &&
      this.state.email.trim() &&
      !emailRegex.test(this.state.email)
    ) {
      errors.email = emailError;
      valid = false;
    }
    // Mobile money logic (if serviceType=PAID)
    if (this.state.serviceType === "PAID") {
      if (!this.state.mobileMoney || !this.state.mobileMoney.trim()) {
        errors.mobileMoney = "Mobile Money Number is required";
        valid = false;
      } else if (!this.state.mobileMoneyVerified) {
        errors.mobileMoney = "Mobile Money Number must be verified";
        valid = false;
      }
    }
    this.setState({ errors, valid });
    return valid;
  }

  handleRegister(e) {
    e.preventDefault();
    this.setState({ loading: true, msg: "", toastColor: "" });
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
      });
      this.setState({ loading: false });
      return;
    }
    const req = {
      user: {
        username: this.state.username,
        password: this.state.password,
        userType: "INDIVIDUAL",
        fullName: [
          this.state.firstname,
          this.state.middlename,
          this.state.surname,
        ].join(" "),
        mobileVerified: this.state.mobileMoneyVerified ? "YES" : "NO",
        activeStatus: "YES",
        emailVerified: "NO",
        isPaidService: "NO",
      },
      profile: {
        firstName: this.state.firstname,
        middleName: this.state.middlename,
        surname: this.state.surname,
        nationalIdNumber: this.state.identification,
        passportNumber: this.state.passportNumber,
        cellPhone: this.state.cellphone,
        gender: this.state.gender,
        email: this.state.email,
        mobileMoneyNumber: this.state.mobileMoney,
        nationality: this.state.nationality,
        houseNumberStreet: this.state.address,
        suburb: this.state.suburb,
        townCityId: this.state.townCityId,
      },
    };
    var self = this;
    axios
      .post(API + "/register/individualsave", req)
      .then(function (response) {
        if (response.data.success) {
          self.setState({
            msg: "Registration successful! Redirecting to login...",
            toastColor: "success",
          });
          setTimeout(() => {
            window.location.href = "/";
          }, 1600);
        } else {
          self.setState({
            msg: response.data.message || "Registration failed",
            toastColor: "danger",
          });
          if (
            response.data.message &&
            response.data.message.includes("username already exist")
          ) {
            self.setState({
              errors: { ...self.state.errors, username: response.data.message },
            });
          }
        }
      })
      .catch(function (error) {
        self.setState({
          msg:
            error?.response?.data?.message ||
            "Registration failed. Please try again.",
          toastColor: "danger",
        });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  handleVerifyMobileMoney() {
    // Simulate API call to verify mobile money.
    this.setState({ showVerifyPopup: true });
  }
  handleAcceptMobileMoney() {
    this.setState(
      { mobileMoneyVerified: true, showVerifyPopup: false },
      this.validate
    );
  }
  handleCancelMobileMoney() {
    this.setState(
      { mobileMoneyVerified: false, mobileMoney: "", showVerifyPopup: false },
      this.validate
    );
  }

  getIndividualLookupData() {
    var self = this;
    axios
      .get(API + "/register/getindividualdropdownlists")
      .then(function (response) {
        self.setState(
          { individualLookupData: response.data || {} },
          self.validate
        );
      })
      .catch(function (error) {
        self.setState({
          msg:
            error?.response?.data?.message ||
            "Failed to get lookup data. Refresh page or contact administrator.",
          toastColor: "danger",
        });
      });
  }

  async verifyCellphone(e) {
    if (e) e.preventDefault();
    this.setState({ showCellVerifyPopup: true });

    e.preventDefault();
    this.setState({ loading: true, msg: "", toastColor: "" });

    if (!this.state.cellphone) {
      const errors = this.state.errors;
      errors.cellphone = "Cellphone is required";
      this.setState({ errors, valid: false, loading: false });
      return;
    }
    if (!phoneRegex.test(this.state.cellphone)) {
      const errors = this.state.errors;
      errors.cellphone = phoneError;
      this.setState({ errors, valid: false, loading: false });
      return;
    }

    await axios
      .post(API + "/register/mobile/generateotpcode", null, {
        params: {
          mobile: this.state.cellphone,
        },
      })
      .then((response) => {
        this.setState(
          { cellOtpId: response.data, showCellVerifyPopup: true },
          this.validate
        );
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          msg: error?.response?.data?.message || "Failed to get OTP.",
          toastColor: "danger",
        });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }
  verifyCellphoneOtp(otp) {
    // Should handle OTP verification and set cellVerified true if ok (omitted).
    this.setState({
      cellOtp: otp,
      cellVerified: true,
      showCellVerifyPopup: false,
    });
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }
    const lookup = s.individualLookupData;
    if (s.loading) {
      return <Spinner className="" />;
    }
    return (
      <div className="min-h-screen flex flex-col ">
        <Banner title="Register as Individual" />
        {divMsg}
        <form
          className={`flex flex-col items-center w-full mt-2`}
          autoComplete="off"
          onSubmit={this.handleRegister}
        >
          <div className="w-full max-w-5xl">
            <div className="grid grid-cols-2 gap-x-8 gap-y-4">
              <div className="input-group">
                <label className="input-group-text">Firstname</label>
                <input
                  name="firstname"
                  className={`form-control ${
                    s.errors.firstname ? " !border-red-500" : ""
                  }`}
                  value={s.firstname}
                  onChange={this.handleChange}
                  required
                  autoFocus
                />
                {s.errors.firstname && (
                  <span className="input-group-error">
                    {s.errors.firstname}
                  </span>
                )}
              </div>
              <div className="input-group">
                <label className="input-group-text">Middle Name</label>
                <input
                  name="middlename"
                  className={`form-control ${
                    s.errors.middlename ? " !border-red-500" : ""
                  }`}
                  value={s.middlename}
                  onChange={this.handleChange}
                />
                {s.errors.middlename && (
                  <span className="input-group-error">
                    {s.errors.middlename}
                  </span>
                )}
              </div>
              <div className="input-group">
                <label className="input-group-text">Surname</label>
                <input
                  name="surname"
                  className={`form-control ${
                    s.errors.surname ? " !border-red-500" : ""
                  }`}
                  value={s.surname}
                  onChange={this.handleChange}
                  required
                />
                {s.errors.surname && (
                  <span className="input-group-error">{s.errors.surname}</span>
                )}
              </div>
              <div className="input-group">
                <label className="input-group-text">Nationality</label>
                <Select
                  value={(lookup.countrys || []).filter(
                    ({ value }) => value === s.nationality
                  )}
                  onChange={(e) => {
                    this.handleId("", "identification");
                    this.handleId("", "passportNumber");
                    this.setState({ idPlaceholder: ogPlaceholder });
                    this.handleSelect("nationality", e ? e.value : "");
                  }}
                  className={`form-control ${
                    s.errors.nationality ? " !border-red-500" : ""
                  }`}
                  required
                  options={lookup.countrys || []}
                />
                {s.errors.nationality && (
                  <span className="input-group-error">
                    {s.errors.nationality}
                  </span>
                )}
              </div>
              {!!s.nationality && this.isZimbabwean() ? (
                <div className="input-group">
                  <label className="input-group-text">National ID</label>
                  <input
                    name="identification"
                    className={`form-control ${
                      s.errors.identification ? " !border-red-500" : ""
                    }`}
                    value={s.identification}
                    placeholder={s.idPlaceholder}
                    onChange={(e) =>
                      this.handleId(e.target.value, "identification")
                    }
                    required
                  />
                  {s.errors.identification && (
                    <span className="input-group-error">
                      {s.errors.identification}
                    </span>
                  )}
                </div>
              ) : !!s.nationality ? (
                <div className="input-group">
                  <label className="input-group-text">Passport Number</label>
                  <input
                    name="passportNumber"
                    className={`form-control ${
                      s.errors.passportNumber ? " !border-red-500" : ""
                    }`}
                    value={s.passportNumber}
                    onChange={(e) =>
                      this.handleId(e.target.value, "passportNumber")
                    }
                    required
                  />
                  {s.errors.passportNumber && (
                    <span className="input-group-error">
                      {s.errors.passportNumber}
                    </span>
                  )}
                </div>
              ) : null}
              <div className="input-group">
                <label className="input-group-text">Gender</label>
                <select
                  name="gender"
                  className={`form-control ${
                    s.errors.gender ? " !border-red-500" : ""
                  }`}
                  value={s.gender}
                  onChange={this.handleChange}
                  required
                >
                  <option value="">Select</option>
                  {(lookup.genders || []).map((gender) => (
                    <option key={gender} value={gender}>
                      {gender}
                    </option>
                  ))}
                </select>
                {s.errors.gender && (
                  <span className="input-group-error">{s.errors.gender}</span>
                )}
              </div>
              <div className="col-span-1">
                <div className="input-group relative">
                  <label className="input-group-text">Cellphone</label>
                  <input
                    name="cellphone"
                    className={`form-control ${
                      s.errors.cellphone ? " !border-red-500" : ""
                    }`}
                    value={s.cellphone}
                    onChange={this.handleChange}
                    required={true}
                  />
                  {s.errors.cellphone && (
                    <span className="input-group-error">
                      {s.errors.cellphone}
                    </span>
                  )}
                  {!s.cellVerified &&
                    s?.errors?.cellphone?.includes("verified") && (
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={this.verifyCellphone}
                      >
                        Verify
                      </button>
                    )}
                </div>
              </div>
              <div className="col-span-2 input-group">
                <label className="input-group-text">Email</label>
                <input
                  name="email"
                  type="email"
                  className={`form-control ${
                    s.errors.email ? " !border-red-500" : ""
                  }`}
                  value={s.email}
                  onChange={this.handleChange}
                />
                {s.errors.email && (
                  <span className="input-group-error">{s.errors.email}</span>
                )}
              </div>
              <div className="col-span-2 input-group">
                <label className="input-group-text">House No & Street</label>
                <input
                  name="address"
                  className={`form-control ${
                    s.errors.address ? " !border-red-500" : ""
                  }`}
                  value={s.address}
                  onChange={this.handleChange}
                  required
                />
                {s.errors.address && (
                  <span className="input-group-error">{s.errors.address}</span>
                )}
              </div>
              <div className="input-group">
                <label className="input-group-text">Suburb</label>
                <input
                  name="suburb"
                  className={`form-control ${
                    s.errors.suburb ? " !border-red-500" : ""
                  }`}
                  value={s.suburb}
                  onChange={this.handleChange}
                  required
                />
                {s.errors.suburb && (
                  <span className="input-group-error">{s.errors.suburb}</span>
                )}
              </div>
              <div className="input-group">
                <label className="input-group-text">Town/City</label>
                <Select
                  value={(lookup.townCitys || []).filter(
                    ({ value }) => value === s.townCityId
                  )}
                  onChange={(e) =>
                    this.handleSelect("townCityId", e ? e.value : 0)
                  }
                  className={`form-control ${
                    s.errors.townCityId ? " !border-red-500" : ""
                  }`}
                  required
                  options={lookup.townCitys || []}
                />
                {s.errors.townCityId && (
                  <span className="input-group-error">
                    {s.errors.townCityId}
                  </span>
                )}
              </div>
              <div className="input-group">
                <label className="input-group-text">Username</label>
                <input
                  name="username"
                  className={`form-control ${
                    s.errors.username ? " !border-red-500" : ""
                  }`}
                  value={s.username}
                  onChange={this.handleChange}
                  required
                />
                {s.errors.username && (
                  <span className="input-group-error">{s.errors.username}</span>
                )}
              </div>
              <div></div>
              <div className="input-group">
                <label className="input-group-text">Password</label>
                <input
                  name="password"
                  type="password"
                  className={`form-control ${
                    s.errors.password ? " !border-red-500" : ""
                  }`}
                  value={s.password}
                  onChange={this.handleChange}
                  required
                />
                {s.errors.password && (
                  <span className="input-group-error">{s.errors.password}</span>
                )}
              </div>
              <div className="input-group">
                <label className="input-group-text">Password Confirm</label>
                <input
                  name="passwordConfirm"
                  type="password"
                  className={`form-control ${
                    s.errors.passwordConfirm ? " !border-red-500" : ""
                  }`}
                  value={s.passwordConfirm}
                  onChange={this.handleChange}
                  required
                />
                {s.errors.passwordConfirm && (
                  <span className="input-group-error">
                    {s.errors.passwordConfirm}
                  </span>
                )}
              </div>
              <div className="input-group">
                <label className="input-group-text">Service Type</label>
                <select
                  name="serviceType"
                  className={`form-control ${
                    s.errors.serviceType ? " !border-red-500" : ""
                  }`}
                  value={s.serviceType}
                  onChange={this.handleChange}
                  required
                >
                  <option value="">Select</option>
                  {(lookup.serviceTypes || []).map((type) => (
                    <option key={type} value={type}>
                      {type}
                    </option>
                  ))}
                </select>
                {s.errors.serviceType && (
                  <span className="input-group-error">
                    {s.errors.serviceType}
                  </span>
                )}
              </div>
              {s.serviceType === "PAID" && (
                <div className="input-group relative">
                  <label className="input-group-text">
                    Mobile Money Number
                  </label>
                  <input
                    name="mobileMoney"
                    className={`form-control ${
                      s.errors.mobileMoney ? " !border-red-500" : ""
                    }`}
                    value={s.mobileMoney}
                    onChange={this.handleChange}
                    required={s.serviceType === "PAID"}
                  />
                  {s.errors.mobileMoney && (
                    <span className="input-group-error">
                      {s.errors.mobileMoney}
                    </span>
                  )}
                  {!s?.errors?.mobileMoney && (
                    <button
                      className="btn btn-success"
                      type="button"
                      onClick={this.handleVerifyMobileMoney}
                    >
                      Verify Now
                    </button>
                  )}
                  {s.showVerifyPopup && (
                    <div style={{ padding: "1em" }}>
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={this.handleAcceptMobileMoney}
                      >
                        Accept
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger mx-2"
                        onClick={this.handleCancelMobileMoney}
                      >
                        Cancel
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="flex justify-center gap-8 mt-2">
              {s.valid && (
                <button type="submit" className="btn btn-success">
                  Register
                </button>
              )}
              <button
                type="button"
                className="btn btn-success"
                onClick={() => window.history.back()}
              >
                Cancel
              </button>
            </div>
          </div>
        </form>
        {s.showCellVerifyPopup && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-start justify-center z-50">
            <div className="bg-white rounded-b-md w-[99%] h-5/6 overflow-y-scroll flex flex-col px-7">
              <Banner
                key={`poll-message-banner`}
                title="Verify cellphone number"
              />
              <div className="flex flex-col items-center justify-center grow">
                <p className="mb-2">
                  Please check and enter the code received via your cellphone
                  number.
                </p>
                <div className="p-5 border border-sky-900 rounded-md">
                  <OtpInput
                    length={5}
                    key={`mobile-money-otp`}
                    onComplete={(code) => {
                      this.setState({ cellOtp: code }, () =>
                        this.verifyCellphoneOtp(code)
                      );
                    }}
                    onReset={(code) => this.setState({ cellOtp: code })}
                  />
                </div>
                <button
                  className="btn btn-success mt-5"
                  onClick={() => {
                    this.setState({
                      cellOtp: "",
                      cellOtpId: undefined,
                      showCellVerifyPopup: false,
                    });
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
        <Footer />
      </div>
    );
  }
}
